import { Carriers } from '../constants/carriers';
import { DebitsValue, RateClass } from '../constants/decision';
import { Products } from '../constants/products';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class AmeritasSI extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.AMERITAS;
  }
  getProduct(): Products {
    return Products.SI;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [
      UserOrganization.AMERITAS,
      UserOrganization.ETHOS,
      UserOrganization.INTEGRA,
    ].includes(org);
  }
  getColor(): string {
    return 'Brown';
  }
  showDebits(rateClass: string | undefined): boolean {
    return !!rateClass && rateClass !== RateClass.PREFERREDPLUS;
  }
  getDebitsList(): DebitsValue[] {
    return [
      DebitsValue.Debits_N50,
      DebitsValue.Debits_N25,
      DebitsValue.Debits_0,
      DebitsValue.Debits_25,
      DebitsValue.Debits_50,
      DebitsValue.Debits_75,
      DebitsValue.Debits_100,
      DebitsValue.Debits_125,
      DebitsValue.Debits_150,
    ];
  }
  ETIAvailable(): boolean {
    return true;
  }
  public scriptCheckAvailable(): boolean {
    return true;
  }
}
